import React from "react";
import { Link } from "react-router-dom";
import SEO from "../SEO";
import hero from "../assets/images/720x600 hero.png";

const Hero = (props) => {
  return (
    <>
     <SEO 
        title="PPDDEH – Your Ultimate Hub for Hacking & Coding Tutorials| Music Tutorials"
        description="Learn ethical hacking, coding, and music mixing for free on PPDDEH! Watch tutorials, AMVs, and expert guides to enhance your skills in technology and music creation."
        url="https://www.ppddeh.com/"
      />
    <section className={`text-gray-600 body-font bg-${props.mode}`}>
      <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
        {/* left section */}
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1
            className={` title-font sm:text-4xl text-3xl mb-4 font-medium text-900`}
          >
            Welcome to PPDDEH
          </h1>
          <br />
          <h1
            className={`title-font sm:text-4xl text-3xl mb-4 font-medium text-900`}
          >
            Learn Hacking, Coding and more for free!
          </h1>
          <br />
          <p className="mb-8 leading-relaxed">
            I make music videos, tutorial, music mixing, amv and more, this
            website for you all to help you browse my all contents
          </p>

          <div className="flex justify-center">
            <Link to="/blog">
              <button className="blog inline-flex text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-purple-600 rounded text-lg">
                Blog
              </button>
            </Link>
            <Link to="/courses">
              <button className="courses ml-4 inline-flex text-gray-700 bg-gray-100 border-0 py-2 px-6 focus:outline-none hover:bg-gray-200 rounded text-lg">
                Courses
              </button>
            </Link>
          </div>
        </div>

        {/* right section */}
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <img
            className="object-cover object-center rounded"
            alt="hero"
            src={hero}
          />
        </div>
      </div>
    </section>
    </>
    
  );
};

export default Hero;
